"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.YellowCircleIcon = void 0;
const react_1 = __importDefault(require("react"));
const Theme_1 = require("../../Theme/Theme");
const YellowCircleIcon = (_a) => {
    var { onClick } = _a, props = __rest(_a, ["onClick"]);
    return (react_1.default.createElement("svg", Object.assign({ width: "14", height: "15", viewBox: "0 0 14 15", fill: "none", xmlns: "http://www.w3.org/2000/svg", onClick: onClick }, props),
        react_1.default.createElement("circle", { cx: "7", cy: "7.5", r: "7", fill: Theme_1.theme.palette.YELLOW_100 })));
};
exports.YellowCircleIcon = YellowCircleIcon;
